export default "__VITE_ASSET__1hsOmY_J__"